import { MetadataSection } from "./MetadataSection";

type RenderMetadataProps = {
  idx: number;
  data: [string, Array<{ id: string; name: string }>];
  context: any;
};

export const RenderMetadata = ({ idx, data, context }: RenderMetadataProps) => {
  const [label, tags] = data;
  return <MetadataSection key={idx} label={label} tags={tags} className={context.className} />;
};
